export const formatAccountNumberLast4 = (accountNumber: string) => {
  if (!accountNumber) return ''
  return accountNumber.slice(-4)
}
